import * as React from "react";
import { LoadingSpinner } from "./LoadingSpinner";

export interface ContentLoadBlockProps {
    children?: React.ReactChild | React.ReactChild[];
    loading: boolean;
}

export class ContentLoadBlockComponent extends React.Component<ContentLoadBlockProps, any> {
    render() {
        const { loading, children } = this.props;
        return (
            <>
                {loading ? (
                    <tr>
                        <td colSpan={9} style={{ fontSize: "1rem" }}>
                            <LoadingSpinner className="centered-loading" />
                        </td>
                    </tr>
                ) : (
                    children
                )}
            </>
        );
    }
}
